
import { Component, Mixins, Watch } from "vue-property-decorator";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import Property from "@/model/property";
import DateTimeGenerator from "@/common/mixins/dateTimeGenerator";
import QFloorSelect from "@/common/qFloorSelect.vue";
import QErrors from "@/common/qErrors.vue";
import QCompanySelect from "@/common/qCompanySelect.vue";
import QUserSelect from "@/common/qUserSelect.vue";
import postalCodeApi from "@/api/postalCodeApi";
import FloorPlan from "@/model/floor";
import qNotify from "@/common/qNotify";
import Location from "@/model/location";
import click2Top from "@/common/directives/click2Top";
import RepairContentEdit from "@/components/repair-content/repairContentEdit.vue";
import RepairContent from "@/model/repairContent";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import propertyApi from "@/api/propertyApi";
import RepairContentHistory from "@/components/repair-content/repairContentHistory.vue";
import store from "@/store";
import QSelect2 from "@/common/qSelect2.vue";
import moment from "moment";
import {namespace} from "vuex-class";
import {compareWithKeys} from "@/common/utils";
const routerStore = namespace("Router");
@Component({
  name: "PropertyUpdateComponent",
  directives: {
    click2Top,
  },
  components: {
    QPaginate,
    QTableHeader,
    QFloorSelect,
    QErrors,
    QCompanySelect,
    QUserSelect,
    RepairContentEdit,
    RepairContentHistory,
    QSelect2,
  },
})
export default class PropertyUpdateComponent extends Mixins(DateTimeGenerator) {
  public propertyObject = new Property();
  public propertyObjectInit = new Property();
  @routerStore.Getter
  public getSearchParameters!:any;

  public listYear = this.getYears();
  public listMonth = this.getMonths();
  public listDay = this.getDays();
  public errors = {};
  public year = null;
  public month = null;
  public monthTemp = null;
  public day = null;
  public showPopupEdit = false;
  public repairEditTime = 0;
  public yearConfig = {
    width: '100px',
    tags: true,
  };

  async mounted() {
    if (this.isEdit) {
      await this.getPropertyDetail();
      await this.getPostalCode();
    } else {
      this.parseDateTimeInput();
    }
    await this.checkHistory();
    this.propertyObjectInit = _.cloneDeep(this.propertyObject)
  }

  get getPropertyId() {
    return this.$route.params.id;
  }

  get isEdit() {
    return this.$route.name !== "admin.property-create";
  }

  get repairList() {
    this.repairEditTime; // hack for update
    // display repair location newest
    return this.propertyObject.repair_contents_tmp;
  }

  public async getPropertyDetail() {
    const result = await propertyApi.show(this.getPropertyId);
    this.propertyObject = result;
    this.parseDateTimeInput();
  }

  public parseDateTimeInput() {
    if (this.propertyObject.date_of_construction) {
      [this.year, this.month, this.day] =
        this.propertyObject.date_of_construction
          .split("-")
          .map((item) => Number.parseInt(item));
      if (!this.listYear.includes(this.year)) {
        this.listYear.push(this.year);
      }
    }
  }

  public updateRepair(repair: RepairContent) {
    const index = this.propertyObject.repair_contents_tmp.findIndex(
      (item) =>
        (item._id && item._id === repair._id) ||
        (item.id && item.id === repair.id)
    );
    if (index > -1) {
      this.propertyObject.repair_contents_tmp[index] = repair;
    }
    this.repairEditTime++;
  }
  public removeRepairTmp(id: string) {
    const index = _.findIndex(
      this.propertyObject.repair_contents_tmp,
      (item) => (item._id && item._id === id) || (item.id && item.id === id)
    );
    if (index > -1) {
      this.propertyObject.repair_contents_tmp.splice(index, 1);
    }
  }

  public addRepairContent() {
    const mode = this.isEdit ? "exists-property" : "new-property";
    if (!this.propertyObject.floor_plan_id) {
      qNotify.error({
        text: this.$t("properties.must_be_select_floor_plan"),
      });
      return;
    }
    const repair = new RepairContent();
    repair.floor_plan = this.propertyObject.floor_plan;
    repair.property = this.propertyObject;
    if (!this.isEdit) {
      repair.check_validate = true;
    } else {
      repair.property_id = this.propertyObject.id;
    }
    (this.$refs.repairContentPopup as RepairContentEdit).show(
      repair,
      mode,
      this.propertyObject.repair_contents_tmp
    );
  }

  public editRepairContent(repair: RepairContent) {
    const mode = this.isEdit ? "exists-property" : "new-property";
    const repairObject = new RepairContent(repair);
    if (!this.isEdit) {
      repair.check_validate = true;
    } else {
      repair.property_id = this.propertyObject.id;
    }
    repairObject.floor_plan = this.propertyObject.floor_plan;
    (this.$refs.repairContentPopup as RepairContentEdit).show(
      repairObject,
      mode,
      this.propertyObject.repair_contents_tmp
    );
  }

  public changeFloor(floor) {
    this.propertyObject.floor_plan = floor || new FloorPlan();
  }

  public async getPostalCode() {
    if (this.propertyObject.zip_code.trim() === "") {
      this.propertyObject.location = new Location();
      this.errors = {};
      return;
    }

    const result = await postalCodeApi.show(this.propertyObject.zip_code);
    if (result) {
      this.propertyObject.location = result;
      this.errors = {};
    } else {
      this.propertyObject.location = new Location();
      this.errors = {
        zip_code: [this.$t("common.zip_code_not_found")],
      };
    }
  }

  public onAddNewRepair(repair: RepairContent) {
    if (!this.isEdit) {
      repair._id = uuidv4();
    }
    this.propertyObject.repair_contents_tmp.push(repair);
  }

  public changeDateOfConstruction() {
    if (moment(`${this.year}-${this.month}-${this.day}`, 'YYYY-M-D', true).isValid()) {
      this.propertyObject.date_of_construction = `${this.year}-${this.month}-${this.day}`;
    } else {
      this.propertyObject.date_of_construction = 'INVALID_DATE';
    }
  }

  public async submit() {
    const result = await this.propertyObject.save();

    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t("properties.can_not_created"),
      });
      this.errors = result.meta.errors;
    } else {
      qNotify.success({
        text: this.isEdit
          ? this.$t("properties.updated")
          : this.$t("properties.created"),
      });
      this.$router.push({ name: "admin.property" , query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
    }
  }

  public cancel() {
    if (this.isChangedProperty()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.property" , query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$router.push({ name: "admin.property" , query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
    }
  }

  public async remove() {
    this.$modal.showDelete({
      text: "削除を実行します。この操作は取り消せません。",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await this.propertyObject.remove();
        if (result.status === 200) {
          qNotify.success({
            text: this.$t("properties.deleted"),
          });
          this.$router.push({ name: "admin.property", query: this.getSearchParameters ? this.getSearchParameters.propertyList : null });
        } else {
          qNotify.error({
            text: result.data.meta.message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public addFloor() {
    // { name: 'admin.floor-create' }
    // dispatch('ride/clearUserData', null, { root: true })
    store.dispatch("Property/setProperty", this.propertyObject);
    // console.log(this.$store.state);    // this.$router.push({ name: "admin.floor-create" });
    this.$router.push({ name: "admin.floor-create" });
  }

  public async checkHistory() {
    const result = store.state.Property.property;
    if (result) {
      this.$modal.show({
        text: this.$t("recover"),
        onConfirm: async () => {
          this.propertyObject = result;
          const dateConstructionFormat = moment(moment(this.propertyObject.date_of_construction, 'YYYY-MM-DD'));
          this.year = dateConstructionFormat.year();
          this.monthTemp = dateConstructionFormat.month();
          this.month = 1 + this.monthTemp;
          this.day = dateConstructionFormat.date();
          store.dispatch("Property/setProperty", null);
        },
        onClose: () => {
          store.dispatch("Property/setProperty", null);
        },
      });
    }
  }

  public duplicate() {
    this.$router.push({ name: "admin.property-create" }, () => {
      qNotify.success({
        text: this.$t("properties.duplicate"),
      });
      this.propertyObject.id = null;
      this.propertyObject.manage_number = "";
      this.propertyObject.repair_contents = [];
      this.propertyObject.repair_contents_tmp = [];
    });
  }

  public changeSelfServe() {
    if (this.propertyObject.self_serve) {
      this.propertyObject.owner_company_id = null;
      this.propertyObject.person_in_charge_id = null;
    }
  }

  public isChangedProperty() {
    return compareWithKeys(this.propertyObject, this.propertyObjectInit, [
      'manage_number',
      'name',
      'room_number',
      'zip_code',
      'exact_address',
      'company_id',
      'owner_company_id',
      'person_in_charge_id',
      'self_serve',
      'date_of_construction',
      'floor_plan_id',
      // 'floor_plan.id',
      'type',
      'structure',
      'acreage',
      'floor_plan_type',
      'remarks',
    ])
  }

  public duplicateRepairContent(repairContent: RepairContent) {
    repairContent.id = null;
    if (!this.isEdit) {
      repairContent._id = null;
    }
    const mode = this.isEdit ? "exists-property" : "new-property";
    (this.$refs.repairContentPopup as RepairContentEdit).show(
      repairContent,
      mode,
      this.propertyObject.repair_contents_tmp,
      true
    );
  }

  @Watch('month')
  public async updateChangeDateListByMonth() {
    let result;
    if (this.year !== null) {
      result = await this.getDateListByChangeDate(this.year + '-' + this.month);
    } else {
      result = this.getDays()
    }

    this.listDay = result
  }

  @Watch('year')
  public async updateChangeDateListByYear() {
    let result;
    if (this.month !== null) {
      result = await this.getDateListByChangeDate(this.year + '-' + this.month);
    } else {
      result = this.getDays()
    }

    this.listDay = result
  }
}
